import { createFileRoute } from '@tanstack/react-router';

import { GettingStartedPage } from '@/features/docs';

export const Route = createFileRoute('/_authed/docs/')({
  component: GettingStartedPage,
});
